import "../../../node_modules/react-modal-video/scss/modal-video.scss";

const VideoModal = () => {
  return <></>;
};

export default VideoModal;
